import React, { useEffect, useState } from 'react'
import "./Home.css"
import PlanetsData from "../assets/data.json"
import mercuryImg from "../assets/Pictures/planet-mercury.svg"
import  mercuryInternal from "../assets/Pictures/planet-mercury-internal.svg"
import  mercuryGeology from "../assets/Pictures/geology-mercury.png"
import venusImg from "../assets/Pictures/planet-venus.svg"
import venusInternal from "../assets/Pictures/planet-venus-internal.svg"
import venusGeology from "../assets/Pictures/geology-venus.png"
import earthImg from "../assets/Pictures/planet-earth.svg"
import earthInternal from "../assets/Pictures/planet-earth-internal.svg"
import earthGeology from "../assets/Pictures/geology-earth.png"
import marsImg from "../assets/Pictures/planet-mars.svg"
import marsInternal from "../assets/Pictures/planet-mars-internal.svg"
import marsGeology from "../assets/Pictures/geology-mars.png"
import jupiterImg from "../assets/Pictures/planet-jupiter.svg"
import jupiterInternal from "../assets/Pictures/planet-jupiter-internal.svg"
import jupiterGeology from "../assets/Pictures/geology-jupiter.png"
import saturnImg from "../assets/Pictures/planet-saturn.svg"
import saturnInternal from "../assets/Pictures/planet-saturn-internal.svg"
import saturnGeology from "../assets/Pictures/geology-saturn.png"
import uranusImg from "../assets/Pictures/planet-uranus.svg"
import uranusInternal from "../assets/Pictures/planet-uranus-internal.svg"
import uranusGeology from "../assets/Pictures/geology-uranus.png"
import neptuneImg from "../assets/Pictures/planet-neptune.svg"
import neptuneInternal from "../assets/Pictures/planet-neptune-internal.svg"
import neptuneGeology from "../assets/Pictures/geology-neptune.png"

const Home = (props) => {
  console.log(props.getname)
  // console.log(PlanetsData)
  console.log(PlanetsData[0].name)
  const [mercuryImgClass , setmercuryImgClass] = useState("")
  const [mercuryIntClass , setmercuryIntClass] = useState("")
  const [mercuryGeoClass , setmercuryGeoClass] = useState("")
  const [venusImgClass , setvenusImgClass] = useState("")
  const [venusIntClass , setvenusIntClass] = useState("")
  const [venusGeoClass , setvenusGeoClass] = useState("")
  const [earthImgClass , setearthImgClass] = useState("")
  const [earthIntClass , setearthIntClass] = useState("")
  const [earthGeoClass , setearthGeoClass] = useState("")
  const [marsImgClass , setmarsImgClass] = useState("")
  const [marsIntClass , setmarsIntClass] = useState("")
  const [marsGeoClass , setmarsGeoClass] = useState("")
  const [jupiterImgClass , setjupiterImgClass] = useState("")
  const [jupiterIntClass , setjupiterIntClass] = useState("")
  const [jupiterGeoClass , setjupiterGeoClass] = useState("")
  const [saturnImgClass , setsaturnImgClass] = useState("")
  const [saturnIntClass , setsaturnIntClass] = useState("")
  const [saturnGeoClass , setsaturnGeoClass] = useState("")
  const [uranusImgClass , seturanusImgClass] = useState("")
  const [uranusIntClass , seturanusIntClass] = useState("")
  const [uranusGeoClass , seturanusGeoClass] = useState("")
  const [neptuneImgClass , setneptuneImgClass] = useState("")
  const [neptuneIntClass , setneptuneIntClass] = useState("")
  const [neptuneGeoClass , setneptuneGeoClass] = useState("")
  const [planetname , setPlanetname] = useState("")
  const [overViewData , setOverViewData] = useState("")
  const [sourceData , setsourceData] = useState("")
  const [rotation , setrotationData] = useState("")
  const [revolutionData , setrevolutionData] = useState("")
  const [radiusData , setradiusData] = useState("")
  const [temperatureData , settemperatureData] = useState("")
  const [overViewBtnStaus, setOvrviewBtnStatus] =useState(true)
  const [structureBtnStaus, setStructureBunStatus] =useState(false)
  const [geologyBtnStaus, setGeologyBtnStatus] =useState(false)
  const [overviewBtnClass,setOverviewBtnClass] = useState("hideDataBtn")
  const [structureBtnClass,setstructureBtnClass] = useState("hideDataBtn")
  const [geologyBtnClass,setgeologyBtnClass] = useState("")
  useEffect(()=>{
    if(props.getname==="Mercury"){
      setPlanetname(PlanetsData[0].name)
      setrotationData(PlanetsData[0].rotation)
      setrevolutionData(PlanetsData[0].revolution)
      setradiusData(PlanetsData[0].radius)
      settemperatureData(PlanetsData[0].temperature)
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Mercury" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[0].overview.content)
      setsourceData(PlanetsData[0].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      // showing Imgs
      setmercuryImgClass("mercuryImgShow")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Mercury" && structureBtnStaus===true){
      setOverViewData(PlanetsData[0].structure.content)
      setsourceData(PlanetsData[0].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
       // showing Imgs
       setmercuryImgClass("mercuryImgHide")
       setmercuryIntClass("mercuryIntShow")
       setmercuryGeoClass("mercuryGroHide")
       setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Mercury" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[0].geology.content)
      setsourceData(PlanetsData[0].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
       // showing Imgs
       setmercuryImgClass("mercuryImgHide")
       setmercuryIntClass("mercuryIntHide")
       setmercuryGeoClass("mercuryGroShow")
       setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Venus"){
      setPlanetname(PlanetsData[1].name)
      setOverViewData(PlanetsData[1].overview.content)
      setsourceData(PlanetsData[1].overview.source)
      setrotationData(PlanetsData[1].rotation)
      setrevolutionData(PlanetsData[1].revolution)
      setradiusData(PlanetsData[1].radius)
      settemperatureData(PlanetsData[1].temperature)
      setmercuryImgClass("mercuryImgHide")
      setvenusImgClass("vnsuImgShow")
      setearthImgClass("earthImgHide")
      setmarsImgClass("marImgHide")
      setjupiterImgClass("jupiterImgHide")
      setsaturnImgClass("saturnImgHide")
      seturanusImgClass("uranusImgHide")
      setneptuneImgClass("neptuneImgHide")
    }
    if(props.getname==="Venus" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[1].overview.content)
      setsourceData(PlanetsData[1].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgShow")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Venus" && structureBtnStaus===true){
      setOverViewData(PlanetsData[1].structure.content)
      setsourceData(PlanetsData[1].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntShow")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Venus" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[1].geology.content)
      setsourceData(PlanetsData[1].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoShow")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Earth"){
      setPlanetname(PlanetsData[2].name)
      setOverViewData(PlanetsData[2].overview.content)
      setsourceData(PlanetsData[2].overview.source)
      setrotationData(PlanetsData[2].rotation)
      setrevolutionData(PlanetsData[2].revolution)
      setradiusData(PlanetsData[2].radius)
      settemperatureData(PlanetsData[2].temperature)
      setmercuryImgClass("mercuryImgHide")
      setvenusImgClass("vnsuImgHide")
      setearthImgClass("earthImgShow")
      setmarsImgClass("marImgHide")
      setjupiterImgClass("jupiterImgHide")
      setsaturnImgClass("saturnImgHide")
      seturanusImgClass("uranusImgHide")
      setneptuneImgClass("neptuneImgHide")
    }
    if(props.getname==="Earth" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[2].overview.content)
      setsourceData(PlanetsData[2].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgShow")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Earth" && structureBtnStaus===true){
      setOverViewData(PlanetsData[2].structure.content)
      setsourceData(PlanetsData[2].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntShow")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Earth" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[2].geology.content)
      setsourceData(PlanetsData[2].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoShow")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Mars"){
      setPlanetname(PlanetsData[3].name)
      setOverViewData(PlanetsData[3].overview.content)
      setsourceData(PlanetsData[3].overview.source)
      setrotationData(PlanetsData[3].rotation)
      setrevolutionData(PlanetsData[3].revolution)
      setradiusData(PlanetsData[3].radius)
      settemperatureData(PlanetsData[3].temperature)
      setmercuryImgClass("mercuryImgHide")
      setvenusImgClass("vnsuImgHide")
      setearthImgClass("earthImgHide")
      setmarsImgClass("marImgShow")
      setjupiterImgClass("jupiterImgHide")
      setsaturnImgClass("saturnImgHide")
      seturanusImgClass("uranusImgHide")
      setneptuneImgClass("neptuneImgHide")
    }
    if(props.getname==="Mars" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[3].overview.content)
      setsourceData(PlanetsData[3].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgShow")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Mars" && structureBtnStaus===true){
      setOverViewData(PlanetsData[3].structure.content)
      setsourceData(PlanetsData[3].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntShow")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Mars" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[3].geology.content)
      setsourceData(PlanetsData[3].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoShow")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Jupiter"){
      setPlanetname(PlanetsData[4].name)
      setOverViewData(PlanetsData[4].overview.content)
      setsourceData(PlanetsData[4].overview.source)
      setrotationData(PlanetsData[4].rotation)
      setrevolutionData(PlanetsData[4].revolution)
      setradiusData(PlanetsData[4].radius)
      settemperatureData(PlanetsData[4].temperature)
      setmercuryImgClass("mercuryImgHide")
      setvenusImgClass("vnsuImgHide")
      setearthImgClass("earthImgHide")
      setmarsImgClass("marImgHide")
      setjupiterImgClass("jupiterImgShow")
      setsaturnImgClass("saturnImgHide")
      seturanusImgClass("uranusImgHide")
      setneptuneImgClass("neptuneImgHide")
    }
    if(props.getname==="Jupiter" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[4].overview.content)
      setsourceData(PlanetsData[4].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgShow")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Jupiter" && structureBtnStaus===true){
      setOverViewData(PlanetsData[4].structure.content)
      setsourceData(PlanetsData[4].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntShow")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Jupiter" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[4].geology.content)
      setsourceData(PlanetsData[4].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoShow")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Saturn"){
      setPlanetname(PlanetsData[5].name)
      setOverViewData(PlanetsData[5].overview.content)
      setsourceData(PlanetsData[5].overview.source)
      setrotationData(PlanetsData[5].rotation)
      setrevolutionData(PlanetsData[5].revolution)
      setradiusData(PlanetsData[5].radius)
      settemperatureData(PlanetsData[5].temperature)
      setmercuryImgClass("mercuryImgHide")
      setvenusImgClass("vnsuImgHide")
      setearthImgClass("earthImgHide")
      setmarsImgClass("marImgHide")
      setjupiterImgClass("jupiterImgHide")
      setsaturnImgClass("saturnImgShow")
      seturanusImgClass("uranusImgHide")
      setneptuneImgClass("neptuneImgHide")
    }
    if(props.getname==="Saturn" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[5].overview.content)
      setsourceData(PlanetsData[5].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgShow")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Saturn" && structureBtnStaus===true){
      setOverViewData(PlanetsData[5].structure.content)
      setsourceData(PlanetsData[5].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntShow")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Saturn" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[5].geology.content)
      setsourceData(PlanetsData[5].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoShow")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Uranus"){
      setPlanetname(PlanetsData[6].name)
      setOverViewData(PlanetsData[6].overview.content)
      setsourceData(PlanetsData[6].overview.source)
      setrotationData(PlanetsData[6].rotation)
      setrevolutionData(PlanetsData[6].revolution)
      setradiusData(PlanetsData[6].radius)
      settemperatureData(PlanetsData[6].temperature)
      setmercuryImgClass("mercuryImgHide")
      setvenusImgClass("vnsuImgHide")
      setearthImgClass("earthImgHide")
      setmarsImgClass("marImgHide")
      setjupiterImgClass("jupiterImgHide")
      setsaturnImgClass("saturnImgHide")
      seturanusImgClass("uranusImgShow")
      setneptuneImgClass("neptuneImgHide")
    }
    if(props.getname==="Uranus" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[6].overview.content)
      setsourceData(PlanetsData[6].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgShow")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Uranus" && structureBtnStaus===true){
      setOverViewData(PlanetsData[6].structure.content)
      setsourceData(PlanetsData[6].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntShow")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Uranus" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[6].geology.content)
      setsourceData(PlanetsData[6].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoShow")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Neptune"){
      setPlanetname(PlanetsData[7].name)
      setOverViewData(PlanetsData[7].overview.content)
      setsourceData(PlanetsData[7].overview.source)
      setrotationData(PlanetsData[7].rotation)
      setrevolutionData(PlanetsData[7].revolution)
      setradiusData(PlanetsData[7].radius)
      settemperatureData(PlanetsData[7].temperature)
      setmercuryImgClass("mercuryImgHide")
      setvenusImgClass("vnsuImgHide")
      setearthImgClass("earthImgHide")
      setmarsImgClass("marImgHide")
      setjupiterImgClass("jupiterImgHide")
      setsaturnImgClass("saturnImgHide")
      seturanusImgClass("uranusImgHide")
      setneptuneImgClass("neptuneImgShow")
    }
    if(props.getname==="Neptune" && overViewBtnStaus===true){
      setOverViewData(PlanetsData[7].overview.content)
      setsourceData(PlanetsData[7].overview.source)
      setOverviewBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgShow")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Neptune" && structureBtnStaus===true){
      setOverViewData(PlanetsData[7].structure.content)
      setsourceData(PlanetsData[7].structure.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("showDataBtn")
      setgeologyBtnClass("hideDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntShow")
      setneptuneGeoClass("neptuneGeoHide")
    }
    if(props.getname==="Neptune" && geologyBtnStaus===true){
      setOverViewData(PlanetsData[7].geology.content)
      setsourceData(PlanetsData[7].geology.source)
      setOverviewBtnClass("hideDataBtn")
      setstructureBtnClass("hideDataBtn")
      setgeologyBtnClass("showDataBtn")
      //showing images
      setmercuryImgClass("mercuryImgHide")
      setmercuryIntClass("mercuryIntHide")
      setmercuryGeoClass("mercuryGroHide")
      setvenusImgClass("vnsuImgHide")
      setvenusIntClass("vnsuIntHide")
      setvenusGeoClass("vnsuGeoHide")
      setearthImgClass("earthImgHide")
      setearthIntClass("earthIntHide")
      setearthGeoClass("earthGeoHide")
      setmarsImgClass("marImgHide")
      setmarsIntClass("marIntHide")
      setmarsGeoClass("marGeoHide")
      setjupiterImgClass("jupiterImgHide")
      setjupiterIntClass("jupiterIntHide")
      setjupiterGeoClass("jupiterGeoHide")
      setsaturnImgClass("saturnImgHide")
      setsaturnIntClass("saturnIntHide")
      setsaturnGeoClass("saturnGeoHide")
      seturanusImgClass("uranusImgHide")
      seturanusIntClass("uranusIntHide")
      seturanusGeoClass("uranusGeoHide")
      setneptuneImgClass("neptuneImgHide")
      setneptuneIntClass("neptuneIntHide")
      setneptuneGeoClass("neptuneGeoShow")
    }
  })
  const overviewFunction =()=>{
    if(overViewBtnStaus === false){
      setOvrviewBtnStatus(true)
      setStructureBunStatus(false)
      setGeologyBtnStatus(false)
    }
  }
  const structureFunction =()=>{
    if(structureBtnStaus === false){
      setOvrviewBtnStatus(false)
      setStructureBunStatus(true)
      setGeologyBtnStatus(false)
    }
  }
  const geologyunction =()=>{
    if(geologyBtnStaus === false){
      setOvrviewBtnStatus(false)
      setStructureBunStatus(false)
      setGeologyBtnStatus(true)
    }
  }
  return (
    <div className='home'>
      <div className='mainPlantPagelayout'>
      <div className='planetImages'>
        <div className='mercuryimges'>
          <img className={mercuryImgClass} src={mercuryImg} alt='planetImg'/>
          <img className={mercuryIntClass} src={mercuryInternal} alt='planetImg'/>
          <img className={mercuryGeoClass}  src={mercuryGeology} alt='planetImg'/>
        </div>
        <div className='venusImages'>
          <img className={venusImgClass} src={venusImg} alt='planetImg'/>
          <img className={venusIntClass} src={venusInternal} alt='planetImg'/>
          <img className={venusGeoClass} src={venusGeology} alt='planetImg'/>
        </div>
        <div className='earthImages'>
          <img className={earthImgClass} src={earthImg} alt='planetImg'/>
          <img className={earthIntClass} src={earthInternal} alt='planetImg'/>
          <img className={earthGeoClass} src={earthGeology} alt='planetImg'/>
        </div>
        <div className='marsImages'>
         <img className={marsImgClass} src={marsImg} alt='planetImg'/>
         <img className={marsIntClass} src={marsInternal} alt='planetImg'/>
         <img className={marsGeoClass} src={marsGeology} alt='planetImg'/>
        </div>
        <div className='jupiterImages'>
          <img className={jupiterImgClass} src={jupiterImg} alt='planetImg'/>
          <img className={jupiterIntClass} src={jupiterInternal} alt='planetImg'/>
          <img className={jupiterGeoClass} src={jupiterGeology} alt='planetImg'/>
        </div>
        <div className='saturnImages'>
          <img className={saturnImgClass} src={saturnImg} alt='planetImg'/>
          <img className={saturnIntClass} src={saturnInternal} alt='planetImg'/>
          <img className={saturnGeoClass} src={saturnGeology} alt='planetImg'/>
        </div>
        <div className='uranusImages'>
          <img className={uranusImgClass} src={uranusImg} alt='planetImg'/>
          <img className={uranusIntClass} src={uranusInternal} alt='planetImg'/>
          <img className={uranusGeoClass} src={uranusGeology} alt='planetImg'/>
        </div>
        <div className='neptuneImages'>
          <img className={neptuneImgClass} src={neptuneImg} alt='planetImg'/>
          <img className={neptuneIntClass} src={neptuneInternal} alt='planetImg'/>
          <img className={neptuneGeoClass} src={neptuneGeology} alt='planetImg'/>
        </div>
      </div>
      <div className='sningedatatemplate'>
      <h1>{planetname}</h1>
      <p>{overViewData}</p>
      <p className='planetLinks'>Source: <a className='plaetSource' href={sourceData}> Wikipedia <i className="fa-solid fa-arrow-up-right-from-square"></i></a></p>
      <div className='planetDataBtns'>
        <button className={overviewBtnClass} onClick={overviewFunction}>01 OVERVIEW</button>
        <button className={structureBtnClass} onClick={structureFunction}>02 INTERNAL STRUCTURE </button>
        <button className={geologyBtnClass} onClick={geologyunction}>03 SURFACE GEOLOGY </button>
      </div>
      </div>
      </div>
      <div className='keyPoints'>
        <div className='homeBoxs'>
        <p className=''>ROTATION TIME</p>
          <h2>{rotation}</h2>
        </div>
        <div className='homeBoxs'>
        <p className=''>REVOLUTION TIME</p>
          <h2>{revolutionData}</h2>
        </div>
        <div className='homeBoxs'>
        <p className=''>RADIUS</p>
          <h2>{radiusData}</h2>
        </div>
        <div className='homeBoxs'>
        <p className=''>AVERAGE TEMP</p>
          <h2>{temperatureData}</h2>
        </div>
      </div>
      <h3 className='dev'>
          <a href='https://sidemenuportfolio.netlify.app/' rel="noreferrer" target='_blank'>&copy;Jobayer Rahman <i className="fa-solid fa-arrow-up-right-from-square"></i></a>
        </h3>
    </div>
  )
}

export default Home
